export const aboutData = {
    title: "Who I am",
    description1: "My name's Raghvendra. I'm  Lead Software developer based in India. Current Working with Deutche Telekom on OTT app OneTV for 13 Europe country",
    description2: "Around 8 yr of Product Development/Management experience Super-app developement, OTT, Food Delivery, Edtec, Fintech, IOT based, Tracking based, apps ecosystem developement",
    image: 1
}